/**
 * Warnung unter der Bullet-Points-Zeile: Text wird erzeugt, laesst sich aber
 * mangels Bullet-Mapping nicht in den Channel pushen. Verlinkt direkt in die
 * Integrations-Einstellungen, damit der Nutzer den Lauf nicht abbrechen muss.
 */

import { AlertTriangle } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface ChannelBulletWarningProps {
  channelLabel: string
}

export function ChannelBulletWarning({ channelLabel }: ChannelBulletWarningProps) {
  const { t } = useTranslation()

  return (
    <div
      role="status"
      className="mx-4 mb-2 flex items-start gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-800 dark:border-amber-700 dark:bg-amber-950/30 dark:text-amber-300"
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <span>
        {t('channelContent.wizard.bulletPushWarning', { channel: channelLabel })}{' '}
        <Link
          to="/v2/workspace-settings"
          className="font-medium underline underline-offset-2"
        >
          {t('channelContent.wizard.addBulletMapping')}
        </Link>
      </span>
    </div>
  )
}
